import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoUr: CultureInfo = {
  name: 'ur',
  displayName: 'Urdu',
  iso3LanguageCode: 'urd',
  iso2LanguageCode: 'ur',
  ietfLanguageTag: 'ur',
  parent: null
};
